import React, { useState, useRef, useEffect } from 'react';
import { Search, X, Check } from 'lucide-react';

const WarehouseSelect = ({ warehouses, selectedWarehouse, onChange, label }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const filteredWarehouses = warehouses.filter(warehouse =>
    warehouse.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelect = (warehouseId) => {
    onChange(warehouseId);
    setIsOpen(false);
  };

  const getSelectedWarehouseName = () => {
    const warehouse = warehouses.find(w => w._id === selectedWarehouse);
    return warehouse ? warehouse.name : '';
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label} 
      </label>
      <div
        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm cursor-pointer bg-white"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="flex items-center justify-between px-3 py-2">
          {selectedWarehouse ? (
            <span className="text-sm text-gray-900">{getSelectedWarehouseName()}</span>
          ) : (
            <span className="text-sm text-gray-500">Select warehouse...</span>
          )}
          {selectedWarehouse && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                onChange('');
              }}
              className="text-gray-400 hover:text-gray-500"
            >
              <X className="h-4 w-4" />
            </button>
          )}
        </div>
      </div>

      {isOpen && (
        <div className="absolute z-10 mt-1 w-full bg-white border rounded-md shadow-lg">
          <div className="p-2 border-b">
            <div className="relative">
              <Search className="absolute left-2 top-2.5 h-4 w-4 text-gray-400" />
              <input
                type="text"
                className="pl-8 pr-4 py-2 w-full border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Search warehouses..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onClick={(e) => e.stopPropagation()}
              />
            </div>
          </div>

          <div className="max-h-60 overflow-y-auto">
            {filteredWarehouses.length > 0 ? (
              filteredWarehouses.map((warehouse) => (
                <div
                  key={warehouse._id}
                  className="flex items-center px-4 py-2 hover:bg-gray-50 cursor-pointer"
                  onClick={() => handleSelect(warehouse._id)}
                >
                  <div className="flex items-center flex-1">
                    <div className="w-4 h-4 border rounded mr-3 flex items-center justify-center">
                      {selectedWarehouse === warehouse._id && (
                        <Check className="h-3 w-3 text-blue-600" />
                      )}
                    </div>
                    <div>
                      <span className="text-sm font-medium text-gray-900">{warehouse.name}</span>
                      <p className="text-xs text-gray-500">{warehouse.location}</p>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="px-4 py-2 text-sm text-gray-500">
                No warehouses found
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default WarehouseSelect;